import { render, staticRenderFns } from "./uploadPic.vue?vue&type=template&id=89a64e02"
import script from "./uploadPic.vue?vue&type=script&lang=js"
export * from "./uploadPic.vue?vue&type=script&lang=js"
import style0 from "./uploadPic.vue?vue&type=style&index=0&id=89a64e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports